import { useContext, useEffect, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Invoices/CancelInvoice.css";
import { AppContext } from "../../../AppProvider";
import { InvoiceContext } from "./InvoiceProvider";
import { billingMicroserviceUrl } from "../../../../microservices/billing_microservice";

const CancelInvoice = () =>{
    const {user,logout} = useContext(AppContext);
    const [cancellingInvoiceStatus,setCancellingInvoiceStatus] = useState('');
    const {
        setReloadInvoices,
        selectedToCancelInvoice,setSelectedToCancelInvoice
    } = useContext(InvoiceContext);
    const cancelInvoice = async() => {
        try{
            setCancellingInvoiceStatus('cancelling');
            const url = `${billingMicroserviceUrl}/tenants/invoices/created/${selectedToCancelInvoice?.id}`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setCancellingInvoiceStatus('cancelled');
                setReloadInvoices(true);
                return;
            }
        }
        catch(error){
            console.error(`An error occurred when cancelling invoice with invoice no: ${selectedToCancelInvoice?.invoiceNumber}`,error)
        }
        setCancellingInvoiceStatus('error');
    };
    useEffect(() =>{
        const handleEsc = (e) =>{
            if(e.key === "Escape" && cancellingInvoiceStatus !== 'deleting') setSelectedToCancelInvoice(null);
        };
        document.addEventListener("keydown",handleEsc);
        return () =>{
            document.removeEventListener("keydown",handleEsc);
        };
    },[selectedToCancelInvoice,cancellingInvoiceStatus]);
    useEffect(() =>{
        setCancellingInvoiceStatus('');
    },[selectedToCancelInvoice]);
    if(!selectedToCancelInvoice) return null;
    return(
        <div className="tenant-administrator-cancel-invoice-parent-container">
            {cancellingInvoiceStatus === ''?
                (
                    <div className="tenant-administrator-cancel-invoice-container">
                        <h1>Cancel invoice "{selectedToCancelInvoice?.invoiceNumber || ''}"?</h1>
                        <p>Invoice will change status from issued to created.</p>
                        <div className="tenant-administrator-cancel-invoice-buttons-container">
                            <button className="do-not-cancel-button"
                                onClick={() => setSelectedToCancelInvoice(null)}>
                                Don't cancel
                            </button>
                            <button className="cancel-button"
                                onClick={() => cancelInvoice()}>
                                Cancel invoice
                            </button>
                        </div>
                        <div className="tenant-administrator-cancel-invoice-escape-button-container"
                            onClick={() => setSelectedToCancelInvoice(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):cancellingInvoiceStatus === 'cancelling'? (
                    <div className="tenant-administrator-cancelling-invoice-container">
                        <div></div>
                        <p>Cancelling invoice. Please wait...</p>
                    </div>
                ):cancellingInvoiceStatus === 'cancelled'?
                (
                    <div className="tenant-administrator-cancelled-invoice-container">
                        <h1>Invoice cancelled</h1>
                        <p>Invoice "{selectedToCancelInvoice?.invoiceNumber}" cancelled successfully</p>
                        <div className="tenant-administrator-cancelled-invoice-okay-button-container">
                            <button onClick={() => setSelectedToCancelInvoice(null)}>
                                Okay
                            </button>
                        </div>
                        <div className="tenant-administrator-cancelled-invoice-escape-button-container"
                            onClick={() => setSelectedToCancelInvoice(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <div className="tenant-administrator-invoice-cancel-error-container">
                        <h1>Error</h1>
                        <p>An error occurred when cancelling invoice "{selectedToCancelInvoice?.invoiceNumber}"</p>
                        <div className="tenant-administrator-invoice-cancel-error-okay-button-container">
                            <button onClick={() => setSelectedToCancelInvoice(null)}>Okay</button>
                        </div>
                        <div className="tenant-administrator-invoice-cancel-error-escape-button-container"
                            onClick={() => setSelectedToCancelInvoice(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
export default CancelInvoice;